module.exports = __webpack_public_path__ + "img/CR_airServicesbanner.86f4a530.jpg";